var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-skeleton-loader',_vm._b({staticClass:"mx-3",attrs:{"type":"table-heading, divider, list-item-three-line"}},'v-skeleton-loader',_vm.attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }